import { type JSX, type FC, lazy, Suspense } from "react"

import AspectRatio from "../AspectRatio"
import { BunnyPlayer } from "../VideoPlayer"

const ApiVideo = lazy(() => import("./ApiVideo"))

type Props = {
	video: { playableDate?: Date | null } & (
		| { host: "apiVideo"; apiVideoId: string }
		| { host: "bunny"; bunnyVideoId: string }
	)
	className?: string
}
const HostedVideoPlayer: FC<Props> = ({ video, className }) => {
	const children: JSX.Element = (() => {
		if (video.playableDate === null)
			return (
				<div className="absolute inset-0 flex items-center justify-center text-2xl font-semibold">
					Processing...
				</div>
			)

		switch (video.host) {
			case "apiVideo":
				return (
					<Suspense fallback={<div>Loading...</div>}>
						<ApiVideo apiVideoId={video.apiVideoId} />
					</Suspense>
				)
			case "bunny":
				return <BunnyPlayer videoId={video.bunnyVideoId} />
		}
	})()

	return (
		<AspectRatio width={{ unit: "percent", value: 100 }} aspectRatio={16 / 9} className={className}>
			{children}
		</AspectRatio>
	)
}

export default HostedVideoPlayer
